import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { Footer } from "@busy-human/vue-component-library";
import Version from '../version.vue';
import { useRouter } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'app-footer',
  setup(__props, { expose: __expose }) {
  __expose();

const router = useRouter();

const appVersion = VERSION;
const appEnv = ENVIRONMENT;
const appBuild = BUILD_HASH;
const versionString = computed(() => (`Version ${appVersion}${appEnv === 'development' ? '_DEV' : ''}`));

const goToLocation = (location: string) => {
	router.push(location);
};

function supportLink(){
	window.location.href='mailto:support@developingtank.com';
}




const __returned__ = { router, appVersion, appEnv, appBuild, versionString, goToLocation, supportLink, computed, get Footer() { return Footer }, Version, get useRouter() { return useRouter } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})